<template>
  <div class="table">
    <app-loading :loading="!loaded">
      <div class="container" v-if="loaded" :class="{blur : (!$store.getters['user/data'].subsPlan)}">
        <app-btn to="/dashboard/plans" class="go-to-plans" v-if="!$store.getters['user/data'].subsPlan">{{$ml.get(`Get the full access to the software`)}}</app-btn>
        <div class="side-fix">
          <div class="item">
            {{ $ml.get(`Nutrient Requirements`) }}
          </div>
          <div v-for="(stage, i) in stages" class="item" :key="i">
            
            <div class="stage-name">{{ stage.name }}</div>

            <div v-if="$store.getters['program/data'].type == 'hydroponic'">
                <app-btn :class="{'drainage-selected' : stage.selectedDrainage}" @click="show(i, stage.id)" class="drainage-add-btn">
                    {{stage.selectedDrainage ? stage.selectedDrainage.name : $ml.get("+ Add drainage")}}
                </app-btn>
              <div :class="{opened : shown == i, loading : loadingDrainages}" class="drainages-dropdown">

                <ul v-if="drainages.length && !loadingDrainages">
                  <li v-for="drainage in drainages">
                    <span :class="{selected : stage.selectedDrainage && stage.selectedDrainage.name == drainage.name}" @click="selectStageDrainage(drainage.drainageId, i)">
                      {{drainage.name}}
                    </span>
                  </li>
                </ul>
                <div @click="removeDrainage(i)" class="remove-drainage__btn" v-if="drainages.length && stage.selectedDrainage && !loadingDrainages">Remove drainage</div>
                <div v-else-if="!drainages.length && !loadingDrainages">{{$ml.get('No drainages found for this step.')}}</div>
                
                <LoadingSVG v-if="loadingDrainages"/>
              </div>
            </div>
          </div>
          <div class="item">
            {{$ml.get('Total')}}
          </div>
        </div>
        <div>
          <carousel :pageCustom="pageCustom">
            <template>
              <div class="row">
                <div class="item">
                  {{ $ml.get(`Duration`) }}
                </div>
                <div class="item" v-for="(stage, j) in stages" :key="j">
                  {{ adjustValues[j].Properties.ActualDuration ? adjustValues[j].Properties.ActualDuration : '-'}}
                </div>
                <div class="item">
                  <b>{{ totalDur ? totalDur : '-' }}</b>
                </div>
              </div>
            </template>

            <template v-if="$store.getters['program/data'].type == 'hydroponic'">
              <div class="row">
                <div class="item">
                  pH
                </div>
                <div class="item" v-for="(stage, j) in stages" :key="j">
                  <template v-if="!$store.getters['user/data'].subsPlan">
                    {{ Math.floor(Math.random() * 100) }}
                  </template>
                  <template v-else>
                    <app-number-input
                      v-model="adjustValues[j].Properties['Ph']"
                      @input="saveNForms"
                      :min="1"
                      :max="14"
                    >
                    </app-number-input>
                  </template>
                </div>
                <div class="item">
                  <b>
                    -
                  </b>
                </div>
              </div>
            </template>

            <template v-if="$store.getters['program/data'].type == 'hydroponic'">
              <div class="row">
                <div class="item">
                  N-NO3
                </div>
                <div class="item" v-for="(stage, j) in stages" :key="j">
                  <template v-if="!$store.getters['user/data'].subsPlan">
                    {{ Math.floor(Math.random() * 100) }}
                  </template>
                  <template v-else-if="adjustValues[j].Nutrients['N_Val']">
                    <app-number-input
                      v-if="stages[j].selectedDrainage && adjustValues[j].Nutrients['NNO3_Val']"
                      @input="(val) => onInputNN(val, j, 'NNO3')"
                      :value="adjustValues[j].Nutrients['NNO3_Val']"
                      :step="0.1"
                      :digits-after-dot="1"
                      :min="0"
                      :max="adjustValues[j].Nutrients['N_Val']"
                    >
                    </app-number-input>
                    <app-number-input
                      v-else
                      @input="(val) => onInputN(val, j, 'NO3')"
                      :value="adjustValues[j].Nutrients['NO3_Val']"
                      :min="0"
                      :max="adjustValues[j].Nutrients['N_Val']"
                      :step="0.1"
                      :digits-after-dot="1"
                    >
                    </app-number-input>
                  </template>
                  <template v-else>
                    -
                  </template>
                </div>
                <div class="item">
                  <b>
                    <template v-if="total['NO3_Val'] && total['N_Val']">
                      {{ total['NO3_Val'].toFixed(2) }} ppm
                    </template>
                    <template v-else>
                      {{ total['NNO3_Val'] ? (total['NO3_Val'] + total['NNO3_Val']).toFixed(2) : total['NO3_Val'].toFixed(2) }} ppm
                    </template>
                  </b>
                </div>
              </div>
            </template>

            <template v-if="$store.getters['program/data'].type == 'hydroponic'">
              <div class="row">
                <div class="item">
                  N-NH4
                </div>
                <div class="item" v-for="(stage, j) in stages" :key="j">
                  <template v-if="!$store.getters['user/data'].subsPlan">
                    {{ Math.floor(Math.random() * 100) }}
                  </template>
                  <template v-else-if="adjustValues[j].Nutrients['N_Val']">
                    <app-number-input
                      v-if="stages[j].selectedDrainage && adjustValues[j].Nutrients['NNH4_Val']"
                      @input="(val) => onInputNN(val, j, 'NNH4')"
                      :value="adjustValues[j].Nutrients['NNH4_Val']"
                      :min="0"
                      :max="adjustValues[j].Nutrients['N_Val']"
                      :step="0.1"
                      :digits-after-dot="1"
                    >

                    </app-number-input>
                    <app-number-input
                      v-else
                      @input="(val) => onInputN(val, j, 'NH4')"
                      :value="adjustValues[j].Nutrients['NH4_Val']"
                      :min="0"
                      :max="adjustValues[j].Nutrients['N_Val']"
                      :step="0.1"
                      :digits-after-dot="1"
                    >

                    </app-number-input>
                  </template>
                  <template v-else>
                    -
                  </template>
                </div>
                <div class="item">
                  <b>
                    <template v-if="total['NH4_Val'] && total['N_Val']">
                      {{ total['NH4_Val'].toFixed(2) }} ppm
                    </template>
                    <template v-else>
                      {{ total['NNH4_Val'] ? (total['NH4_Val'] + total['NNH4_Val']).toFixed(2) : total['NH4_Val'].toFixed(2)}} ppm
                    </template>
                  </b>
                </div>
              </div>
            </template>

            <template v-for="(n, i) in nutrients">
              <div class="row" :key="i">
                <div class="item">
                  {{ n.label }}
                </div>
                <div class="item" v-for="(stage, j) in stages" :key="j">
                  <template v-if="!$store.getters['user/data'].subsPlan">
                    {{ Math.floor(Math.random() * 100) }}
                  </template>
                  <template v-else-if="adjustValues[j].Nutrients[n.label+'_Val']">
                    <!-- {{ adjustValues[j].Nutrients[n.label+'_Val'] }} -->
                    <!-- {{ $store.getters['program/data'].type == 'soil-based' ? 'kg' : 'ppm' }} -->
                    {{ $store.getters['program/data'].type == 'soil-based' ?
                      $store.getters['unit/convert']('kg', adjustValues[j].Nutrients[n.label+'_Val']):
                      adjustValues[j].Nutrients[n.label+'_Val'].toFixed(2)
                    }}
                    {{ $store.getters['program/data'].type == 'soil-based' ? $store.getters['unit/getLabel']('kg') : 'ppm' }}
                  </template>
                  <template v-else>-</template>
                </div>
                <div class="item">
                  <b>
                    <template v-if="total[n.label+'_Val']">
                      <!-- {{ total[n.label+'_Val'].toFixed(2) }} -->
                      <!-- {{ $store.getters['program/data'].type == 'soil-based' ? 'kg' : 'ppm' }} -->
                      {{ $store.getters['program/data'].type == 'soil-based' ?
                        $store.getters['unit/convert']('kg', total[n.label+'_Val']) :
                        total[n.label+'_Val'].toFixed(2)
                      }}
                      {{ $store.getters['program/data'].type == 'soil-based' ? $store.getters['unit/getLabel']('kg') : 'ppm' }}
                    </template>
                    <template v-else>
                      -
                    </template>
                  </b>
                </div>
              </div>
            </template>
          </carousel>
        </div>
      </div>
    </app-loading>
  </div>
</template>

<script>
import API from '@/api'
import { ProgramAPI } from '@/api'
import { mapGetters } from 'vuex'
// import HorScrollShadower from '@/components/common/HorScrollShadower';
import LoadingSVG from '@/components/ui/LoadingSVG'
import Carousel from '@/components/common/carousel/Carousel';
export default {
  props: ['recFlag'],
  components: {
    // HorScrollShadower,
    Carousel,
    LoadingSVG
  },
  data() {
    return {
      adjustValues: [],
      loaded: false,
      stages: [],
      pageCustom: [
        [0, 1],
        [700, 2],
        [800, 3],
        [900, 4],
        [1000, 5],
      ],
      filled: false,
      showDropdown: false,
      shown: null,
      loadingDrainages: false
      }
  },
  created() {
    this.loaded = false;
    this.sync().finally(() => {
      this.loaded = true;
      if(this.adjustValues) this.saveNForms();
    });
  },
  destroyed() {
    this.$store.dispatch('program/canGoToNextStep', true);
  },
  methods: {
    show(i, stageId) {
      if(!this.showDropdown) {
        this.loadingDrainages = true
        this.$store.dispatch('drainage/findByStep', {stageId: stageId}).then(res => {
          console.log(res)
          this.loadingDrainages = false
        })
        this.shown = i;
        this.showDropdown = true;
      } else if (this.showDropdown && this.shown != i) {
        this.loadingDrainages = true
        this.$store.dispatch('drainage/findByStep', {stageId: stageId}).then(res => {
          console.log(res)
          this.loadingDrainages = false
        })
        this.shown = i;
      }
      else {
        this.shown = null
        this.showDropdown = false;
        this.$store.commit('drainage/setUserDrainages', [])
      }
    },
    selectStageDrainage(drainageId, stageIndex) {
      if(this.$store.getters['program/data'].type == 'hydroponic') {
        let stage = this.stages[stageIndex]

        API.drainage.InsertDrainageData({drainageId: drainageId, programId: this.program.id}).then(res => {
          this.adjustValues = res.data.data.data;

          if(res.data.data.drainageUsed != null) {
            stage.selectedDrainage = this.drainages.find(e => {
              return e.drainageId == res.data.data.drainageUsed[stageIndex]
            })
          }

          this.setValues();
        }, rej => {
          console.log(rej)
        }) 

        this.shown = null
        this.showDropdown = false

        
      }
      
    },
    saveNForms() {
      console.log(this.adjustValues)
      if (this.$store.getters['program/data'].type == 'hydroponic' && this.adjustValues.length) {
        
        return API.program.saveNForms(this.program.id, this.adjustValues)
          .then(res => {
          }).catch(e => {
            console.log(e)
          })
      }
    },
    onInputN (val, stage, parent) {
      var originPar = parent + '_Val';
      var subParent = originPar == 'NO3_Val' ? 'NH4_Val' : 'NO3_Val';
      if (this.adjustValues[stage].Nutrients[originPar] > this.adjustValues[stage].Nutrients['N_Val']) {
        return this.$notify({
          group: 'notices',
          title: this.$ml.get(`${parent} cannot exceed N!`),
          type : 'error',
        });
      }
      this.adjustValues[stage].Nutrients[originPar] = val;
      this.adjustValues[stage].Nutrients[subParent] =
        this.adjustValues[stage].Nutrients['N_Val'] - this.adjustValues[stage].Nutrients[originPar];
      
      this.adjustValues[stage].Nutrients[subParent] = this.adjustValues[stage].Nutrients[subParent].toFixed(2)
      this.saveNForms();
    },
    onInputNN (val, stage, parent) {
      var originPar = parent + '_Val';
      var subParent = originPar == 'NNO3_Val' ? 'NNH4_Val' : 'NNO3_Val';
      if (this.adjustValues[stage].Nutrients[originPar] > this.adjustValues[stage].Nutrients['N_Val']) {
        return this.$notify({
          group: 'notices',
          title: this.$ml.get(`${parent} cannot exceed N!`),
          type : 'error',
        });
      }
      this.adjustValues[stage].Nutrients[originPar] = val;
      this.adjustValues[stage].Nutrients[subParent] =
        this.adjustValues[stage].Nutrients['N_Val'] - this.adjustValues[stage].Nutrients[originPar];
        this.adjustValues[stage].Nutrients[subParent] = this.adjustValues[stage].Nutrients[subParent].toFixed(2)
      this.saveNForms();
    },

    async sync() {
      await this.syncAdjust();
      await this.syncStages();
    },
    //=================================================================================
    syncAdjust() {
      return ProgramAPI.getAdjust(this.program.id).then(res => {
        if (res.data.success === false) {
          this.recalculateAdjust();
        } else {
          this.adjustValues = res.data.data;
          this.setValues();
        }
      }).catch(err => {
        
        this.$notify({
          group: 'notices',
          title: this.$ml.get(`Please, check irrigation at previous step in Water tests.`),
          type : 'error',
        });
      })
    },
    //=================================================================================
    setValues() {
      for (let i in this.adjustValues) {
        if(!this.adjustValues[i].Properties.Ph) this.adjustValues[i].Properties['Ph'] = 6
        if((this.$store.getters['program/data'].type == 'hydroponic' && this.adjustValues[i].Nutrients.N_Val) &&
          (!this.adjustValues[i].Nutrients.NO3_Val && !this.adjustValues[i].Nutrients.NH4_Val)) {
          this.adjustValues[i].Nutrients.NO3_Val = this.adjustValues[i].Nutrients.N_Val * .8;
          this.adjustValues[i].Nutrients.NH4_Val = this.adjustValues[i].Nutrients.N_Val - this.adjustValues[i].Nutrients.NO3_Val;
        }
        if ((this.adjustValues[i].Nutrients.N_Val && (this.adjustValues[i].Nutrients.NO3_Val <= 0  && this.adjustValues[i].Nutrients.NH4_Val <= 0)) || this.adjustValues[i].Properties.Ph <= 0) {
          this.filled = false
          break;
        } else this.filled = true
        if (this.$store.getters['program/data'].type == 'hydroponic' && !this.filled) {
          this.$store.commit('modals/prompt/open', {
            text: this.$ml.get('Fill N-NO3, N-NH4 and pH to proceed!'),
          });
          this.$store.dispatch('program/canGoToNextStep', false)
          } else this.$store.dispatch('program/canGoToNextStep', true)
      }
    },
    recalculateAdjust () {
      return ProgramAPI.recalculateAdjust(this.program.id).then(res => {
        this.adjustValues = res.data.data;
        if (!this.$store.getters['user/data'].subsPlan) {
          this.$store.dispatch('program/steps/setCurrentStep', 'general-settings');
        } else {
          this.$store.dispatch('program/steps/setCurrentStep', 'adjusted-values');
          this.setValues();
          this.saveNForms();
        }
        
        
        // this.$store.dispatch('program/steps/setCurrentStepNextFromSelectedStep', 'adjusted-values');
      }).catch(err => {
        this.$notify({
          group: 'notices',
          title: this.$ml.get(`Please fill required data in previous steps!`),
          type : 'error',
        });
      })
    },
    syncStages() {
      if(this.$store.getters['program/data'].type == 'hydroponic') {
        return ProgramAPI.getCropStages({yieldGoalId: this.program.cropYieldGoalId, programId: this.program.id}).then(res => {
          this.stages = res.data.data;
         
          for(let key in res.data.usedDrainages) {
            this.stages[key].selectedDrainage = res.data.usedDrainages[key];
          }
        });
      } else {
        return ProgramAPI.getCropStagesGET(this.program.cropYieldGoalId).then(res => {
          this.stages = res.data.data;
        });
      }
      
    },

    removeDrainage(stageId) {
      return API.drainage.removeDrainageFromStep({programId: this.program.id, stageId}).then(res => {
        let stage = this.stages[stageId];

        this.adjustValues = res.data.data.data;

        stage.selectedDrainage = null;

        this.shown = null;
      })
    }
  },
  computed: {
    ...mapGetters({
      program: 'program/data',
      drainages: 'drainage/drainages'
    }),
    nutrients: function () {
      return this.$store.getters['nutrients/topLevelNutrients'].filter(item => {
        return !['NO3', 'NH4', 'NH2', 'HCO3', 'Al', 'NNO3', 'NNH2', 'NNH4'].includes(item.key);
      });
    },
    total() {
      let _total = {}
      this.adjustValues.map( (el) => {
        for(let n in el.Nutrients) {
          let num = +el.Nutrients[n];

          if(_total[n]) {

            if(typeof el.Nutrients['NNH4_Val'] == 'undefined' && typeof el.Nutrients['NNO3_Val'] == 'undefined')
              _total[n] += num;

            else if(n == 'NNH4_Val' || n == 'NNO3_Val') 
              _total[n] += num

            else if (!(typeof el.Nutrients['NNH4_Val'] == 'undefined' && typeof el.Nutrients['NNO3_Val'] == 'undefined') && !(n == 'NH4_Val' || n == 'NO3_Val')) 
              _total[n] += num

          }else {
            
            if(typeof el.Nutrients['NNH4_Val'] == 'undefined' && typeof el.Nutrients['NNO3_Val'] == 'undefined') 
              _total[n] = num

            else if(n == 'NNH4_Val' || n == 'NNO3_Val') 
              _total[n] = num

            else if (!(typeof el.Nutrients['NNH4_Val'] == 'undefined' && typeof el.Nutrients['NNO3_Val'] == 'undefined') && !(n == 'NH4_Val' || n == 'NO3_Val'))
              _total[n] = num
          }
        }
      })
      console.log(_total)
      return _total
    },
    totalDur() {
      let _total = 0
      this.adjustValues.map( (el) => {
        _total += el.Properties.ActualDuration
      })
      return _total
    },
  },
  watch: {
    recFlag: function (val) {
      this.recalculateAdjust();
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  // padding: 0 48px;
  padding-top: 20px;
  // .app-loading {
  //   min-height: 300px;
  // }
  .container {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    .drainage-add-btn {
      font-size: 12px;
      padding-left: 5px;
      padding-right: 5px;
      margin: 0 auto;
      min-height: 16px !important;
      height: 20px;
    }
    .drainages-dropdown {
      width: 100%;
      position: absolute;
      top: 100%;
      left: 0;
      display: none;
      
      z-index: 100;
      background: #fff;
      border: 1px $mainGreen solid;
      border-radius: 0 0 6px 6px;
      padding: 5px;
      overflow: hidden;
      transition: all .2s ease;
      &.opened {
        display: table;
      }
      &.loading {
        height: 50px;
      }
      ul {
        padding: 0;
        margin: 0;
        max-height: 300px;
        overflow: auto;
        li {
          list-style: none;
          span {
            font-size: 16px;
            display: inline-block;
            margin-bottom: 5px;
            width: 100%;
            padding: 3px;
            &.selected {
              background: $mainGreen;
              border-radius: 4px;
              color: #fff;
            }
            &:hover {
              border: 1px solid $mainGreen;
              border-radius: 4px;
              cursor: pointer;
              box-sizing: border-box;
              padding: 2px;
            }
          }
        }
      }
    }
    .item {
      height: 64px;
      border-bottom: 1px solid #eee;
      border-right: 1px solid #eee;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-evenly;
      box-sizing: border-box;
      position: relative;
    }
    .side-fix {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      min-width: 200px;
      .item {
        font-size: 13px;
      }
    }
    > div:last-child {
      width: calc(100% - 200px);
      .row {
        display: flex;
        flex-direction: column;
        width: 100%;
        .item {
          width: 100%;
          &:first-child {
            font-weight: bold;
          }
          .app-number-input {
            min-width: 120px;
          }
        }
      }
    }
  }
  // .hor-scroll-shadower {
  //   flex-grow: 1;
  // }
  // .a-table {
  //   width: 100%;
  //   .head {
  //   }
  //   td {
  //     box-sizing: border-box;
  //     padding: 0;
  //     height: 50px;
  //     padding: 0 20px;
  //     min-width: 150px;
  //   }
  // }
  @media(max-width:768px) {
    .container {
      > div:last-child {
        flex-grow: 1;
      }
      .item {
      }
      .side-fix {
        min-width: unset;
      }
    }
  }
}

.remove-drainage__btn {
  text-align: center;
  background: #d15656;
  color: #fff;
  border-radius: 3px;
  padding: 3px 0;
  &:hover {
    background: #a33737;
    cursor: pointer;
  }
}
</style>
